export default "__VITE_ASSET__b2d79452__"